export default __webpack_public_path__ + "static/media/CG.3ecee2a9.svg";